
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';
import { LazyImage } from '@/hooks/useLazyImage';

interface CtaSectionProps {
  industry?: string;
}

const CtaSection: React.FC<CtaSectionProps> = ({ industry }) => {
  const navigate = useNavigate();
  const { currentLanguage } = useLanguage();
  
  const handleContactClick = () => {
    // Navigate to the correct contact path based on language
    const contactPath = `/${currentLanguage}/${
      currentLanguage === 'de' ? 'kontakt' : 
      currentLanguage === 'it' ? 'contatto' : 'contact'
    }`;
    
    navigate(contactPath);
  };

  return (
    <section className="py-20 bg-[#0A0014] relative overflow-hidden">
      {/* Background pattern - using a gradient instead of potentially broken image */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-900/5 to-transparent pointer-events-none"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <motion.div 
          className="max-w-4xl mx-auto text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            {currentLanguage === 'de' ? 'Bereit für beeindruckende KI-Videos?' :
             currentLanguage === 'en' ? 'Ready for impressive AI videos?' :
             currentLanguage === 'fr' ? 'Prêt pour des vidéos IA impressionnantes?' :
             'Pronto per impressionanti video AI?'}
          </h2>
          
          <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
            {currentLanguage === 'de' ? 'Revolutionieren Sie Ihr Videomarketing mit unseren KI-generierten Videos. Kontaktieren Sie uns jetzt für ein unverbindliches Beratungsgespräch.' :
             currentLanguage === 'en' ? 'Revolutionize your video marketing with our AI-generated videos. Contact us now for a free consultation.' :
             currentLanguage === 'fr' ? 'Révolutionnez votre marketing vidéo avec nos vidéos générées par l\'IA. Contactez-nous maintenant pour une consultation gratuite.' :
             'Rivoluziona il tuo video marketing con i nostri video generati dall\'AI. Contattaci ora per una consulenza gratuita.'}
          </p>
          
          <div className="flex justify-center">
            <motion.button 
              onClick={handleContactClick}
              className="px-8 py-3 bg-[#9B30FF] text-white rounded-lg hover:bg-purple-600 transition-all shadow-lg shadow-purple-900/20 font-medium text-lg"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
            >
              {currentLanguage === 'de' ? 'Kontakt aufnehmen' :
               currentLanguage === 'en' ? 'Get in Touch' :
               currentLanguage === 'fr' ? 'Nous contacter' :
               'Contattaci'}
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CtaSection;
